 
import { useAtomValue } from 'jotai';

import { Stack } from '@ekhodealer/ekho-common/rev';

import { AccordionSection } from '@common/components/AccordionSection';
import { InfoLineItem } from '@common/components/InfoLineItem';

import { useGetInventoryItem } from '../../../api/useGetInventoryItem';
import { drawerAtom } from '../../../atoms/editDrawerAtoms';

export const ModelDetails = () => {
	const { selectedItemId } = useAtomValue(drawerAtom);
	const { data: inventoryItem, isLoading } = useGetInventoryItem(selectedItemId || '');

	// Show loading if actively loading OR if we have an ID but no data yet
	const isDataLoading = isLoading || Boolean(selectedItemId && !inventoryItem);

	const { make, model, modelYear, color } = inventoryItem || {};

	return (
		<AccordionSection title={'Model details'} defaultExpanded>
		<Stack itemsSpacing='16'>
			<InfoLineItem title='Year' value={modelYear?.toString()} isCopyable isLoading={isDataLoading} />
			<InfoLineItem title='Make' value={make} isCopyable isLoading={isDataLoading} />
			<InfoLineItem title='Model' value={model} isCopyable isLoading={isDataLoading} />
			<InfoLineItem title='Color' value={color} isCopyable isLoading={isDataLoading} />
		</Stack>
	</AccordionSection>
	);
};
